import Toolbar from './toolbar.element.js';

export default Toolbar;

Toolbar.define('wje-toolbar', Toolbar);
